/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './style/contactForm.scss';

import React, {FocusEventHandler, MouseEventHandler, useMemo} from 'react';
import {
    ChangeKeyFunction,
    DvrdButton,
    DvrdInput,
    DvrdSelect,
    Loader,
    SelectItemShape,
    preventDefault
} from '@dvrd/dvr-controls';
import {ContactErrors} from "../../util/interfaces";
import {CITIES, formatCitiesString} from "../../util/constants";
import BulbIcon from "../icon/bulb-icon";

interface Props {
    onChange: ChangeKeyFunction<string>;
    onSubmit: MouseEventHandler;
    onResetError: (key: string) => FocusEventHandler;
    name: string;
    email: string;
    phoneNumber: string;
    message: string;
    city: string;
    serviceType: string;
    loading: boolean;
    errors: ContactErrors;
}

const serviceItems: Array<SelectItemShape> = [
    {value: '', label: 'Kies een optie...', selectable: false},
    {value: 'Groep', label: 'Groep'},
    {value: 'Individueel', label: 'Individueel'},
    {value: 'Geen voorkeur', label: 'Geen voorkeur'},
];

export default function ContactForm(props: Props) {
    const {
        onChange, name, onSubmit, loading, email, serviceType, message, phoneNumber, onResetError, errors, city
    } = props;
    const cityItems = useMemo(() => CITIES.map((city: string) => ({value: city, label: city})).concat(
        {value: 'misc', label: 'Overig'}
    ), []);

    function renderCityWarning() {
        return (
            <div className='city-warning'>
                <BulbIcon/>
                <label className='warning'>Bowie's Hondenuitlaatservice haalt alleen honden op
                    in {formatCitiesString()}.</label>
            </div>
        )
    }

    return (
        <div className='contact-form'>
            <div className='header-container'>
                <h2 className='header-title'>Contactformulier</h2>
            </div>
            <form className='body-container' onSubmit={preventDefault}>
                <Loader active={loading}/>
                {city === 'misc' && renderCityWarning()}
                <DvrdInput value={name} onChange={onChange('name')} label='Naam *' disabled={loading}
                           error={errors.name} onFocus={onResetError('name')}/>
                <DvrdInput value={email} onChange={onChange('email')} label='E-mailadres *' disabled={loading}
                           inputProps={{type: 'email'}} error={errors.email} onFocus={onResetError('email')}/>
                <DvrdInput value={phoneNumber} onChange={onChange('phoneNumber')} label='Telefoonnummer'
                           disabled={loading} inputProps={{type: 'phone'}}/>
                <DvrdSelect items={cityItems} value={city} onChange={onChange('city')} label='Woonplaats'/>
                <DvrdInput value={message} onChange={onChange('message')} inputProps={{rows: 5}}
                           label={`Bericht * ${message.length}/500`} disabled={loading} error={errors.message}
                           onFocus={onResetError('message')} area/>
            </form>
            <div className='footer-container'>
                <DvrdButton onClick={onSubmit} label='Verstuur' disabled={loading}/>
            </div>
        </div>
    )
}